import {connect} from 'react-redux'
import TranslationsPanel from '../components/monitoring-translations/monitoring-translations-panel'
import * as modalActions from '../store/modal/actions'
import * as translationsActions from '../store/monitoring-translations/actions'
import * as appActions from '../store/app/actions'

function mapStateToProps (state) {
  return {
    ...state.translations,
    ...state.modal,
    ...state.app,
  }
}

export default connect(mapStateToProps, {...translationsActions, ...modalActions, ...appActions})(TranslationsPanel)



// WEBPACK FOOTER //
// ./src/containers/monitoring-translations-container.js